
//Add and Remove weather includes radar , cloud, windSpeed

import { weatherApiKey, weatherTileServerUrl } from "../Config";

export const addAllWeatherSources = async (mapRef, weatherChecked, weatherOverlayOptions) => {
    if (!weatherOverlayOptions) return;

    try {
        const response = await fetch(weatherTileServerUrl);
        if (!response.ok) {
            throw new Error("Failed to fetch weather data");
        }

        const res = await response.json();
        const { satrad, cloudsFcst, windSpeedNM } = res.seriesInfo;
        const latestTimeSlice = satrad.series[0].ts;
        const latestCloudsFcstTimeSlice = cloudsFcst.series[0].ts;
        const latestCloudsFcstForcastTimeSlice = cloudsFcst.series[0].fts[0];
        const latestCwindSpeedNMTimeSlice = windSpeedNM.series[0].ts;

        const weatherLayers = [
            {
                type: 'radar',
                timeSlice: latestTimeSlice,
                source: 'twcRadar',
                url: `https://api.weather.com/v3/TileServer/tile/satrad?ts=${latestTimeSlice}&xyz={x}:{y}:{z}&apiKey=${weatherApiKey}`
            },
            {
                type: 'cloud',
                timeSlice: latestCloudsFcstTimeSlice,
                source: 'twcClouds',
                url: `https://api.weather.com/v3/TileServer/tile/cloudsFcst?ts=${latestCloudsFcstTimeSlice}&fts=${latestCloudsFcstForcastTimeSlice}&xyz={x}:{y}:{z}&apiKey=${weatherApiKey}`
            },
            {
                type: 'windSpeed',
                timeSlice: latestCwindSpeedNMTimeSlice,
                source: 'windSpeedNM',
                url: `https://api.weather.com/v3/TileServer/tile/windSpeedNM?ts=${latestCwindSpeedNMTimeSlice}&xyz={x}:{y}:{z}&apiKey=${weatherApiKey}`
            }
        ];

        weatherLayers.forEach(layer => {
            if (weatherOverlayOptions?.[layer.type] && !mapRef.getSource(layer.source)) {
                mapRef.addSource(layer.source, {
                    type: 'raster',
                    tiles: [layer.url],
                    tileSize: 1024
                });
            }
        });
        if (weatherChecked) {
            addAllWeatherLayers(mapRef, weatherOverlayOptions);
        };
    } catch (error) {
        console.error("Error fetching weather data:", error);
    }
};

const addAllWeatherLayers = (mapRef, weatherOverlayOptions) => {
    const layers = [
        { id: 'clouds', source: 'twcClouds', condition: weatherOverlayOptions?.cloud },
        { id: 'radar', source: 'twcRadar', condition: weatherOverlayOptions?.radar },
        { id: 'windSpeed', source: 'windSpeedNM', condition: weatherOverlayOptions?.windSpeed }
    ];
    layers.forEach(layer => {
        if (layer.condition) {
            mapRef.addLayer({
                id: layer.id,
                type: 'raster',
                source: layer.source,
                paint: { 'raster-opacity': 0.3 }
            });
        }
    });
};

const removeAllWeatherLayers = (mapRef, weatherOverlayOptions) => {
    const layers = [
        { id: 'radar', source: 'twcRadar', condition: weatherOverlayOptions?.radar },
        { id: 'clouds', source: 'twcClouds', condition: weatherOverlayOptions?.cloud },
        { id: 'windSpeed', source: 'windSpeedNM', condition: weatherOverlayOptions?.windSpeed }
    ];
    layers.forEach(layer => {
        if (layer.condition && mapRef.getLayer(layer.id)) {
            mapRef.removeLayer(layer.id);
        }
    });
};